import { render, staticRenderFns } from "./AddOrderAdditionalCostPopUp.vue?vue&type=template&id=165b7750&scoped=true&"
import script from "./AddOrderAdditionalCostPopUp.vue?vue&type=script&lang=js&"
export * from "./AddOrderAdditionalCostPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderAdditionalCostPopUp.vue?vue&type=style&index=0&id=165b7750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b7750",
  null
  
)

export default component.exports